import { Box } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'

import CertificationRequestQ from '@/queries/CertificationRequestQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'
import { getCertificationUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import { useToaster } from '@/components/Toast/useToaster'

let hasPresentedCertificationToast = false

export default function CertificationPeerReviewToast() {
  const user = useUser()
  const query = useQuery()
  const toast = useToaster()
  const router = useRouter()

  const inProgressCertificationsCount = query`COUNT(*) ${CertificationRequestQ.where({
    userId: user.id,
    reviewed: 'unreviewed',
    readyForReview: false,
  })}`

  const isOnCertifyPage = router.pathname.startsWith('/topic/[topic]/certify')
  const shouldPresentToast = inProgressCertificationsCount > 0 && !isOnCertifyPage

  const presentToast = useCallback(() => {
    if (hasPresentedCertificationToast) {
      return
    }
    hasPresentedCertificationToast = true

    toast({
      description: (
        <Box>
          You have {inProgressCertificationsCount} pending certification
          {inProgressCertificationsCount > 1 ? 's' : ''} that will only be reviewed after you{' '}
          <ShwLink href={getCertificationUrl('review')}>complete peer reviews</ShwLink>.
        </Box>
      ),
      status: 'warning',
      duration: null,
    })
  }, [toast, inProgressCertificationsCount])

  useEffect(() => {
    if (shouldPresentToast) {
      // We add a delay so the toast container has time to mount
      setTimeout(presentToast, 1000)
    }
    // Intentionally only triggering this once, regardless of dependencies
    // oxlint-ignore-next-line react/exhaustive-deps
  }, [])

  return null
}
